import { render, staticRenderFns } from "./DBClient.vue?vue&type=template&id=614df3ed&"
import script from "./DBClient.vue?vue&type=script&lang=js&"
export * from "./DBClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports